export class GlobalEngagementUrlConstants {
  static readonly #COMMON_GLOBAL_ENGAGEMENT_PATH =
    'GlobalEngagements/GlobalEngagements/';
  static readonly #COMMON_GLOBAL_ENGAGEMENT_SUBMISSION_PATH =
    'GlobalEngagements/Submission/';
  static readonly #COMMON_GLOBAL_ENGAGEMENT_SUBMISSION_DOC_PATH =
    'GlobalEngagements/SubmissionDocument/';
  static readonly #COMMON_GLOBAL_ENGAGEMENT_ENGAGE_PATH =
    'GlobalEngagements/Engagement/';

  public static readonly GET_SUBMISSION_TYPE =
    GlobalEngagementUrlConstants.#COMMON_GLOBAL_ENGAGEMENT_PATH +
    'GetSubmissionType';
  public static readonly GET_DELIVERY_CENTER =
    GlobalEngagementUrlConstants.#COMMON_GLOBAL_ENGAGEMENT_PATH +
    'GetDeliveryCenter?isNewSubmission=';
  public static readonly GET_Member_Firm =
    GlobalEngagementUrlConstants.#COMMON_GLOBAL_ENGAGEMENT_PATH +
    'GetMemberFirmDetails';
  public static readonly GET_ACTIONS_REASONS_DROPDOWN =
    GlobalEngagementUrlConstants.#COMMON_GLOBAL_ENGAGEMENT_PATH +
    'GetActionReason?submissionactionid=';
  public static readonly GET_AUDIT_TRAIL_DATA =
    GlobalEngagementUrlConstants.#COMMON_GLOBAL_ENGAGEMENT_PATH +
    'GetAuditTrail?engagementId=';

  public static readonly POST_GLOBAL_ENGAGEMENT_SUBMISSION_DETAILS =
    GlobalEngagementUrlConstants.#COMMON_GLOBAL_ENGAGEMENT_ENGAGE_PATH +
    'UpdateEngagement';
  public static readonly GET_ENGAGEMENT_DETAILS =
    GlobalEngagementUrlConstants.#COMMON_GLOBAL_ENGAGEMENT_ENGAGE_PATH +
    'GetExistingEngagementDetails';
  public static readonly GET_GLOBAL_ENGAGEMENT_DETAILS =
    GlobalEngagementUrlConstants.#COMMON_GLOBAL_ENGAGEMENT_ENGAGE_PATH +
    'GetEngagementDetails?engagementId=';
  public static readonly POST_GLOBAL_ENGAGEMENT_SUBMISSION =
    GlobalEngagementUrlConstants.#COMMON_GLOBAL_ENGAGEMENT_SUBMISSION_PATH +
    'InitiateSubmission';
  public static readonly GET_GLOBAL_ENGAGEMENT_LEFTNAV =
    GlobalEngagementUrlConstants.#COMMON_GLOBAL_ENGAGEMENT_SUBMISSION_PATH +
    'GetLeftMenuSubmissionDetails?engagementId=';
  public static readonly GET_GLOBAL_ENGAGEMENT_SUBMISSION_DETAILS =
    GlobalEngagementUrlConstants.#COMMON_GLOBAL_ENGAGEMENT_SUBMISSION_PATH +
    'GetSubmissionDetails?submissionId=';
  public static readonly PUT_GLOBAL_ENGAGEMENT_SUBMISSION_DETAILS =
    GlobalEngagementUrlConstants.#COMMON_GLOBAL_ENGAGEMENT_SUBMISSION_PATH +
    'UpdateSubmission';
  public static readonly SAVE_ACTION_HISTORY =
    GlobalEngagementUrlConstants.#COMMON_GLOBAL_ENGAGEMENT_SUBMISSION_PATH +
    'SaveSubmissionActionHistory';
  public static readonly GET_ACTION_HISTORY =
    GlobalEngagementUrlConstants.#COMMON_GLOBAL_ENGAGEMENT_SUBMISSION_PATH +
    'GetSubmissionActionHistory?submissionid=';
  public static readonly SUBMISSION_STATUS_UPDATE =
    GlobalEngagementUrlConstants.#COMMON_GLOBAL_ENGAGEMENT_SUBMISSION_PATH +
    'UpdateSubmissionStatus';

  public static readonly GET_ENGAGEMENT_DOCUMENT_STATUS =
    GlobalEngagementUrlConstants.#COMMON_GLOBAL_ENGAGEMENT_SUBMISSION_DOC_PATH +
    'GetDocumentStatus';
  public static readonly GET_ENGAGEMENT_DOCUMENT_TYPE =
    GlobalEngagementUrlConstants.#COMMON_GLOBAL_ENGAGEMENT_SUBMISSION_DOC_PATH +
    'GetDocumentType?submissionTypeId=';
  public static readonly SAVE_ENGAGEMENT_DOCUMENT =
    GlobalEngagementUrlConstants.#COMMON_GLOBAL_ENGAGEMENT_SUBMISSION_DOC_PATH +
    'SaveSubmissionDocument';
  public static readonly EDIT_ENGAGEMENT_DOCUMENT =
    GlobalEngagementUrlConstants.#COMMON_GLOBAL_ENGAGEMENT_SUBMISSION_DOC_PATH +
    'EditSubmissionDocument';
  public static readonly GET_ENGAGEMENT_DOCUMENT =
    GlobalEngagementUrlConstants.#COMMON_GLOBAL_ENGAGEMENT_SUBMISSION_DOC_PATH +
    'GetSubmissionDocumentDetails?submissionId=';
  public static readonly DELETE_ENGAGEMENT_DOCUMENT =
    GlobalEngagementUrlConstants.#COMMON_GLOBAL_ENGAGEMENT_SUBMISSION_DOC_PATH +
    'DeleteSubmissionDocument?submissionDocumentId=';
  public static readonly GET_EFA_ROLES =
    'Admin/GlobalEngagement/GetGlobalEngRoleConfig?roleId=702';
    public static readonly GET_ACTIONS_REASONS_API: string =
    GlobalEngagementUrlConstants.#COMMON_GLOBAL_ENGAGEMENT_PATH +
    'GetActionReason?submissionActionId=';
  public static readonly POST_SUBMISSION_HISTORY_API: string =
    GlobalEngagementUrlConstants.#COMMON_GLOBAL_ENGAGEMENT_SUBMISSION_PATH +
    'SaveSubmissionActionHistory';
  public static readonly GET_SUBMISSION_ACTION_HISTORY: string =
    GlobalEngagementUrlConstants.#COMMON_GLOBAL_ENGAGEMENT_SUBMISSION_PATH +
    'GetSubmissionActionHistory?submissionId=';
    public static readonly GENERATE_GLOBAL_ENGAGEMENTS_PDF =
    'Document/GenerateGlobalEngagementsPDF?submissionId=';
}
